// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dB4_","left":"styles_left__NHiHj"};